import { StarIcon } from 'lucide-react'

import { Body } from './Body'
import { MobileBody } from './MobileBody'

import type { Announcement } from '../types'

export const chileautosHighlightsAnnouncement: Announcement = {
  version: '3.2.0',
  date: '2026-10-16',
  title: 'Destacados de ChileAutos',
  summary: 'Premium, TopSpot, Showcase y TopNitro desde Veekls; primero, un administrador da el permiso.',
  icon: StarIcon,
  Body,
  MobileBody,
}
